import {html, LitElement, type TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import Styles from "./macherbusProject.lit.scss";
import type {DirectiveResult} from "lit/directive.js";
import {templateContent} from "lit/directives/template-content.js";
import {macherbusProjectVoteEvent} from "./macherbusEvents";
import {CHECKBOX_EVENT, type CheckboxEvent} from "../../page/elements/input/inputEvents";
import {ifDefined} from "lit/directives/if-defined.js";


// GoodExampleFor: LitComponent with ShadowDOM and <template>
@customElement("eop-macherbus-project")
export class EopMacherbusProject extends LitElement {

    public static readonly styles = Styles;

    @property({attribute: "content"})
    public contentId: string;
    @property({attribute: "project-id"})
    public projectId: string;
    @property({attribute: "image-src"})
    public imageSrc: string;
    @property({attribute: "image-alt"})
    public imageAlt: string;
    @property({type: Boolean, reflect: true})
    public voted: boolean;

    private textualContent: DirectiveResult;

    public constructor() {
        super();
        this.voted = false;
    }

    public connectedCallback(): void {
        super.connectedCallback();

        const textualContentTemplate = this.resolveTemplateElement(this.contentId);
        if (textualContentTemplate !== null) {
            this.textualContent = templateContent(textualContentTemplate);
        }

        this.addEventListener(CHECKBOX_EVENT, this.handleCheckboxEvent);
    }

    public disconnectedCallback(): void {
        super.disconnectedCallback();
        this.removeEventListener(CHECKBOX_EVENT, this.handleCheckboxEvent);
    }

    private handleCheckboxEvent = (e: Event): void => {
        const value = (e as CheckboxEvent<boolean>).detail.inputValue;
        this.setVoted(value);
    };

    public render(): TemplateResult {
        return html`
            <div class="project-tile">
                <div class="tile-image">
                    <eop-responsive-image
                            image-src=${this.imageSrc}
                            image-alt=${this.imageAlt}
                            max-crop-threshold="0.25"
                    ></eop-responsive-image>
                </div>
                <div class="tile-non-image">
                    <div class="tile-text">
                        ${this.textualContent}
                    </div>
                    <div class="checkbox-container">
                        <eop-checkbox
                                input-id=${(this.projectId)}
                                label=""
                                aria-label=${ifDefined(this.imageAlt)}
                                ?checked=${this.voted}
                                ?required=${false}
                                ?invalid=${false}
                                ?valid=${false}
                                ?warning=${false}
                        ></eop-checkbox>
                    </div>
                </div>
            </div>
        `;
    }

    public setVoted(value: boolean): void {
        this.voted = value;
        this.dispatchEvent(macherbusProjectVoteEvent(this.projectId, value));
    }
}